var _rect, _rect2, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 18",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Costa Rica flag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    fill: "#002B7F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 24,
    height: 3,
    fill: "#FFFFFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 24,
    height: 8,
    fill: "#CE1126"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 13,
    width: 24,
    height: 3,
    fill: "#FFFFFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 16,
    width: 24,
    height: 2,
    fill: "#002B7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCr);
export default __webpack_public_path__ + "static/media/cr.9abc26bfbb56d132f1be6522db87b3ec.svg";
export { ForwardRef as ReactComponent };